import React from "react";
import { useHasPermissions } from "../../hooks/useHasPermissions";
import { PERMISSIONS } from "../../roles";
import PortalV2Only from "../PortalV2Only/PortalV2Only";

const LeadGuard = ({ children }: { children: React.ReactNode }) => {
  const canManageLeads = useHasPermissions(PERMISSIONS.CAN_MANAGE_LEADS);
  return canManageLeads ? <>{children}</> : <PortalV2Only featureName="Lead Retrieval" />;
};

export default LeadGuard;
